"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Datalist;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _InputField = _interopRequireDefault(require("../InputField"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var KEY_CODES = {
  backspace: 8,
  rightArrow: 39
};
var StyledInputField = (0, _styledComponents["default"])(_InputField["default"]).withConfig({
  displayName: "Datalist__StyledInputField",
  componentId: "sc-16glmw7-0"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(["padding-right:1.5rem;&::placeholder{color:", ";opacity:1;}"], theme.color.text);
});
var Container = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Datalist__Container",
  componentId: "sc-16glmw7-1"
})(["position:relative;"]);

var AriaLabel = _styledComponents["default"].span.withConfig({
  displayName: "Datalist__AriaLabel",
  componentId: "sc-16glmw7-2"
})(["position:absolute;left:-9999px;top:-9999px;overflow:hidden;height:0;width:0;"]);

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "Datalist__IconContainer",
  componentId: "sc-16glmw7-3"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;cursor:pointer;position:absolute;right:0.5rem;top:0.8rem;transform:", ";opacity:", ";transition:all 0.3s cubic-bezier(0.2,1,0.6,1.25);z-index:", ";&:hover{transform:scale(1.2);}"], props.visible ? 'scale(1)' : 'scale(0)', props.visible ? 1 : 0, props["delete"] ? '1' : '-1');
});
/**

#### Blue Prism styled `Datalist` component

The **Datalist** component renders a `<input type="text">` to the dom along with a `<datalist>`. children of the **Datalist** will be rendered as children of the `<datalist>` in the dom. The children should be instances of the **Option** component. The **Datalist** should be used with the **FormField** component, which handles labels and the error context.

*/


function Datalist(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? '' : _ref2$id,
      children = _ref2.children,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? '' : _ref2$name,
      _ref2$ariaLabel = _ref2.ariaLabel,
      ariaLabel = _ref2$ariaLabel === void 0 ? '' : _ref2$ariaLabel,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      _ref2$onFocus = _ref2.onFocus,
      onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
      _ref2$onBlur = _ref2.onBlur,
      onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
      _ref2$onKeyDown = _ref2.onKeyDown,
      onKeyDown = _ref2$onKeyDown === void 0 ? function () {} : _ref2$onKeyDown,
      rest = _objectWithoutProperties(_ref2, ["id", "children", "error", "value", "name", "ariaLabel", "onChange", "onFocus", "onBlur", "onKeyDown"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      displayValue = _React$useState2[0],
      setDisplayValue = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      placeholder = _React$useState4[0],
      setPlaceholder = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focused = _React$useState6[0],
      setFocused = _React$useState6[1];

  var inputRef = _react["default"].useRef(null);

  var timeout = _react["default"].useRef(null);

  var datalistRef = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    setDisplayValue(!!value);
  }, [value]);

  _react["default"].useEffect(function () {
    return function () {
      clearTimeout(timeout.current);
    };
  }, []);

  function handleFocus(event) {
    setFocused(true);
    setDisplayValue(false);
    setPlaceholder(value);
    onFocus(event);
  }

  function handleBlur(event) {
    setFocused(false);
    setDisplayValue(!!value);
    setPlaceholder('');
    onBlur(event);
  }

  function handleDelete() {
    setPlaceholder('');
    onChange({
      target: {
        value: '',
        name: name,
        id: id
      }
    });
    clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      inputRef.current.focus();
    }, 50);
  }

  function handleKeyDown(event) {
    switch (event.keyCode) {
      case KEY_CODES.backspace:
        if (placeholder === value) handleDelete();
        break;

      case KEY_CODES.rightArrow:
        setDisplayValue(!!value);
        setPlaceholder('');
    }

    onKeyDown(event);
  }

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(Container, {
    error: error
  }, /*#__PURE__*/_react["default"].createElement(AriaLabel, {
    "aria-live": "polite",
    id: "".concat(id, "-aria-label")
  }, ariaLabel), /*#__PURE__*/_react["default"].createElement(StyledInputField, _extends({
    ref: inputRef,
    type: "text",
    id: id,
    list: "".concat(id, "-list"),
    error: error,
    "aria-invalid": error,
    value: displayValue ? value : '',
    placeholder: placeholder,
    name: name,
    onChange: onChange,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    onFocus: handleFocus,
    "aria-describedby": "".concat(id, "-aria-label")
  }, rest)), /*#__PURE__*/_react["default"].createElement(IconContainer, {
    "delete": true,
    visible: focused,
    "aria-hidden": !focused,
    onMouseDown: handleDelete
  }, /*#__PURE__*/_react["default"].createElement(_uiIcons.Cross, {
    color: theme.color.action,
    size: 16
  })), /*#__PURE__*/_react["default"].createElement(IconContainer, {
    visible: !focused,
    "aria-hidden": focused
  }, /*#__PURE__*/_react["default"].createElement(_uiIcons.CaretDown, {
    color: error ? theme.color.warning : theme.color.action,
    size: 16
  })), /*#__PURE__*/_react["default"].createElement("datalist", {
    ref: datalistRef,
    id: "".concat(id, "-list")
  }, children));
}